import { render, staticRenderFns } from "./_netBody.vue?vue&type=template&id=1391e399&scoped=true"
import script from "./_netBody.vue?vue&type=script&lang=js"
export * from "./_netBody.vue?vue&type=script&lang=js"
import style0 from "./_netBody.vue?vue&type=style&index=0&id=1391e399&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1391e399",
  null
  
)

export default component.exports